export default "__VITE_ASSET__DEiIiF5r__"